import { FC } from "react";
import { InputProps, LabelProps } from "./types";
import { findError } from "./util";
import { STYLE_MAP } from "./styles";
import { FormFieldError } from "./FormFieldError/FormFieldError";
import { Label } from "./Label/Label";

export const FormFieldWrapper: FC<LabelProps & InputProps> = ({
  name,
  errors,
  children,
  label,
  description,
  descriptionType,
  helperText,
  mode = "light",
  className = "mb-5 ",
  hideLabel,
  disabled
}) => {
  const error = findError(name, errors);
  return (
    <div className={className}>
      <Label
        label={label}
        name={name}
        description={description}
        descriptionType={descriptionType}
        mode={mode}
        hideLabel={hideLabel}
      />
      {children}
      {helperText && !disabled && (
        <p className={`${STYLE_MAP[mode]["text"].secondary} text-xs mt-1`}>
          {helperText}
        </p>
      )}
      {error && (
        <FormFieldError error={error.message?.toString() || "required"} />
      )}
    </div>
  );
};
